var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListModule',{attrs:{"label":_vm.$t('components.smart.featuredCompanies.label'),"data":_vm.featuredPostings,"to":_vm.companyURL(),"isLoading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }